import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { BoardPerson, UUID } from "@/lib/types";

/**
 * The @-mention pool for a SINGLE row's comments + description fields: board members
 * (home ∪ shared-into workspaces) ∪ the row's creator ∪ everyone the row is shared with
 * (Phase 4 row_shares — direct users + department members). Row-scoped, so a per-ticket
 * shared-in outsider is offered here and can be tagged, and they can tag the board's
 * members/owners back — see the backend GET /rows/{id}/mention-people.
 *
 * Distinct from useBoardPeople (whole-board members ∪ guests), which stays the source for
 * person-cell / comment-author AVATAR resolution.
 */
export function useRowMentionPeople(rowId: UUID | undefined) {
  return useQuery<BoardPerson[]>({
    enabled: Boolean(rowId),
    queryKey: rowId ? ["rows", rowId, "mention-people"] : ["rows", "void", "mention-people"],
    queryFn: () => api.listRowMentionPeople(rowId as UUID),
    staleTime: 5 * 60_000,
  });
}
